import React, { useEffect, useState } from 'react';
import LayoutComp from 'components/LayoutComp/Index';
import Navigation from 'components/Navigation';
import { QUESTION_TYPE, STATIC_TEXT } from 'utils/constants';
import { BackArrow } from 'utils/svg';
import styles from './styles.module.scss';
import { Checkbox, Col, Row, Tabs } from 'antd';
import { fetchQuestions, handleReportName, handleQuestionsSelection } from './question.action';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'components/ui/Loader';

const { TabPane } = Tabs;

const Questions = ({ history }) => {
  const dispatch = useDispatch();
  const categoriesState = useSelector((state) => state.category);
  const { selectedCategories = [] } = categoriesState;
  const questionsState = useSelector((state) => state.question);

  const [localReportName, setLocalReportName] = useState('');

  const { loader = false, questionsList = [], reportName = '', selectedQuestions } = questionsState;

  useEffect(() => {
    if (selectedCategories.length < 1) {
      history.push('/question_category');
    }
  }, [selectedCategories, history]);

  useEffect(() => {
    if (selectedQuestions.length < 1) {
      dispatch(fetchQuestions(selectedCategories));
    }
    // eslint-disable-next-line
  }, [dispatch, selectedCategories]);

  useEffect(() => {
    setLocalReportName(reportName);
  }, [reportName]);

  const handleNext = () => {
    dispatch(handleReportName(localReportName));
    history.push('/download');
  };

  const handleBack = () => {
    history.push('/question_category');
  };

  const handleChange = (val, index) => {
    let copylist = [...selectedQuestions];
    copylist[index] = val;

    dispatch(handleQuestionsSelection(copylist));
  };

  return (
    <div id="questions">
      {loader && <Loader />}
      <LayoutComp history={history}>
        <div className="back-nav">
          <div onClick={handleBack}>
            <BackArrow />
          </div>
          {reportName}
        </div>

        <p className="sub-heading">{STATIC_TEXT['SELECT_OPTION_TO_DOWNLOAD_YOUR_SURVEY']}</p>

        <Tabs defaultActiveKey="0">
          {questionsList.map((questionCat, index) => (
            <TabPane tab={questionCat.title} key={index}>
              <Checkbox.Group
                value={selectedQuestions[index]}
                onChange={(list) => handleChange(list, index)}
                style={{ width: '100%', display: 'block' }}
                className={styles.qcheckboxgroup}
              >
                <div className={styles.questionCtrl}>
                  <Row style={{ marginBottom: 15 }}>
                    {questionCat.subcategories.map((subcat) => (
                      <React.Fragment key={subcat.id}>
                        {subcat.questions.map((questionItem) => {
                          // Create a unique identifier for each question
                          // const uniqueQuestionId = `${questionCat.id}_${subcat.id}_${questionItem.id}`;
                          return (
                            <Col span={24} key={questionItem.precode}>
                              <div
                                className={`box-shadow ques ${styles.questionResize} ${
                                  !selectedQuestions[index]?.includes(questionItem.precode) &&
                                  styles.notSelected
                                }`}
                              >
                                <div className={styles.question}>
                                  <Checkbox value={questionItem.precode}>
                                    {questionItem.text}
                                  </Checkbox>
                                  <div className={styles.quesType}>
                                    {QUESTION_TYPE[questionItem.type - 1]}
                                  </div>
                                  <ul
                                    className={questionItem.options.length > 4 && styles.litwocol}
                                  >
                                    {questionItem.options.map((option) => (
                                      <li key={`option_${option.preCode}`} span={12}>
                                        <div
                                          className={`${option.isSelected ? styles.active : ''} ${
                                            styles.quetionOptions
                                          }`}
                                        >
                                          {option.text}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </Row>
                </div>
              </Checkbox.Group>
            </TabPane>
          ))}
        </Tabs>

        <div className={`checkbox-legends ${styles.selectall}`}>
          <Checkbox>Deselect to hide your questions</Checkbox>
        </div>

        <Navigation
          isDisabledNext={selectedCategories.length < 1}
          isSHowMessage={true}
          isReset={false}
          isBack={true}
          handleBack={handleBack}
          handleNext={handleNext}
        />
      </LayoutComp>
    </div>
  );
};

export default Questions;
